import { Button, Col, Input, Row } from "antd";

import { useNavigate } from "react-router-dom";

const IntroScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="IntroScreen">
      <div
        style={{
          backgroundImage: "url('1-4.gif')",
          backgroundSize: "auto",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div className="container-fluid">
          <div className="row justify-content-center align-items-center">
            <div className="col text-center mt-40">
              <div style={{ width: "500px", margin: "0 auto" }}>
                {/* <img
                  src="intro.png"
                  alt=""
                  className="scale_img mb-30"
                  style={{ width: "100%" }}
                /> */}
                {/* <img
                src="intro.gif"
                alt=""
                className="scale_img mb-30"
                style={{ width: "100%" }}
              /> */}
              </div>
              <div
                style={{ position: "absolute", bottom: "40px", width: "98%" }}
              >
                <Button
                  type="default"
                  style={{
                    border: "1px solid #000",
                    backgroundColor: "transparent",
                    color: "#000",
                    fontSize: "20px",
                    width: "200px",
                    height: "50px",
                  }}
                  onClick={() => navigate("/dashboard")}
                >
                  Enter
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroScreen;
